import { motion } from "framer-motion";
import { SERIES } from "@/data/products";
import { VialCard } from "./VialCard";
import { Constellations } from "./Constellations";
import { useLang } from "@/i18n/LanguageContext";
import { seriesText } from "@/i18n/translations";
import { reveal } from "@/hooks/reveal";

export const Catalogue = ({ onInquire }) => {
  const { t, lang } = useLang();
  return (
    <section id="catalogue" className="relative bg-black/20 py-24 md:py-32" data-testid="catalogue-section">
      <Constellations />
      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-10">
        {/* Section header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <motion.span
              {...reveal()}
              className="font-mono-tech text-[11px] tracking-[0.35em] uppercase text-[var(--al-gold)]"
            >
              {t.catalogue.eyebrow}
            </motion.span>
            <motion.h2
              {...reveal(0.1)}
              className="font-cinzel font-bold text-white text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.08]"
            >
              {t.catalogue.title[0]}<br />{t.catalogue.title[1]}
            </motion.h2>
          </div>
          <motion.p {...reveal(0.15)} className="font-body text-white/50 text-sm md:text-base max-w-sm md:text-right leading-relaxed">
            {t.catalogue.subtitle}
          </motion.p>
        </div>

        {/* Series */}
        <div className="space-y-24">
          {SERIES.map((series) => {
            const st = seriesText(lang, series.id);
            return (
            <div key={series.id} data-testid={`series-${series.id}`}>
              <motion.div {...reveal()} className="flex items-baseline gap-5 border-t border-white/10 pt-7 mb-10">
                <span className="font-display font-extrabold text-white/15 text-4xl md:text-6xl leading-none">
                  {series.index}
                </span>
                <div>
                  <h3 className="font-cinzel font-bold text-white text-2xl md:text-3xl">
                    {st.name}
                    {st.subtitle && (
                      <span className="block font-body font-normal text-[var(--al-gold)]/80 text-sm mt-1 tracking-normal">
                        {st.subtitle}
                      </span>
                    )}
                  </h3>
                  <p className="font-body text-white/45 text-sm mt-2 max-w-2xl leading-relaxed">
                    {st.blurb}
                  </p>
                </div>
              </motion.div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {series.products.map((product, i) => (
                  <VialCard key={product.id} product={product} index={i} onInquire={onInquire} />
                ))}
              </div>
            </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
